import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetAllOrderHistoriesByCurrentUserPagedFilterQuery } from '../../Common/types/Queries/IGetAllOrderHistoriesByCurrentUserPagedFilterQuery';

export const getAllOrderHistoriesByCurrentUserPagedFilter = createAsyncThunk(
  'Order/getAllDeactiveOrdersByCurrentUserPagedFilter',
  async (query: IGetAllOrderHistoriesByCurrentUserPagedFilterQuery) => {
    return await OrdersHttpGetService({
      url: `${_apiPathManagerConfig?.Orders.Order.GetAllOrderHistoriesByCurrentUserPagedFilter}`,
      params: query,
    });
  }
);
